import {
  SlRange
} from "./chunk.II44SQ5G.js";

// src/components/range/range.ts
var range_default = SlRange;
SlRange.define("sl-range");

export {
  range_default
};
